export default {
  baseStyle: () => ({
    field: {
      bg: 'whiteAlpha.50',
    },
  }),
};
